module.exports = __webpack_public_path__ + "img/bm.ad29105e.svg";